<template>
	<div v-parallax-fit="parallax" class="photo">
		<img src="/themes/rise-theme/dist/images/estate/character-view/holly/12_spider.png" alt="">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 6000,
						end: 7000,
						fromStyle: { transform: 'translateY(-300%) rotateZ(0deg)' },
           				toStyle: { transform: 'translateY(0%) rotateZ(3deg)' },
						easing: 'linear'
					},
					{
						start: 7000,
						end: 8000,
						fromStyle: { transform: 'translateY(0%) rotateZ(3deg)' },
           				toStyle: { transform: 'translateY(300%) rotateZ(3deg)' },
						easing: 'linear'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.photo {
		position: absolute;
		bottom: -8%;
		left: -11%;
		z-index: 2;
		max-width: 500px;
		transition: all 0.1s linear;
	}

	@media screen and (max-width: 1600px) {
        .photo {
            max-width: 400px;
        }
    }

    @media screen and (max-width: 1024px) {
        .photo {
            max-width: 350px;
        }
    }

    @media screen and (max-width: 650px) {
        .photo {
            max-width: 200px;
            left: -5%;
        }
    }
    @media(max-width: 400px) {
      .photo {
        bottom: -68%;
      }
    }
</style>
